// extracted by mini-css-extract-plugin
module.exports = {"available-meals":"AvailableMeals_available-meals__1zorn","loading-meals":"AvailableMeals_loading-meals__5h4EG","http-error":"AvailableMeals_http-error__-Rh2H"};